module.exports = __webpack_public_path__ + "img/order.1ecc7a60.png";